import { createActions } from 'redux-actions';

const actions = createActions({
  GET_DATA: {
    STARTED: undefined
  }
})

const configuration = {
  name: 'started',
  action: actions,
  sagas: undefined,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      isFetchingUserData: true
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getDataStarted.js